/*
This file was created by the script build.py 
*/

import {getAllFiltered} from "./filter";
import {searchObjectFurtherCategorisationHeavyIon} from "./searchObjects"



export function fillSearchObjectFurtherCategorisationHeavyIon(){
    searchObjectFurtherCategorisationHeavyIon.categories = [];
    searchObjectFurtherCategorisationHeavyIon.keywords = [];

    const checkbox = document.getElementById("categoryFurtherCategorisationHeavyIon");
    if(checkbox.checked || checkbox.indeterminate){
        searchObjectFurtherCategorisationHeavyIon.categories.push(checkbox.value);
    }

    const anyButton = document.getElementById("buttonFurtherCategorisationHeavyIonAny");
    if(anyButton.classList.contains("chosen")){
        searchObjectFurtherCategorisationHeavyIon.any = true;
    }

    const allButton = document.getElementById("buttonFurtherCategorisationHeavyIonAll");
    if(allButton.classList.contains("chosen")){
        searchObjectFurtherCategorisationHeavyIon.any = false;
    }
    
    const buttonEllipticFlowandeventproperties = document.getElementById("buttonFurtherCategorisationHeavyIonEllipticFlowandeventproperties");
    if(buttonEllipticFlowandeventproperties.classList.contains('selected')){
        searchObjectFurtherCategorisationHeavyIon.keywords.push(buttonEllipticFlowandeventproperties.value)
    }
    
    const buttonForwardphysics = document.getElementById("buttonFurtherCategorisationHeavyIonForwardphysics");
    if(buttonForwardphysics.classList.contains('selected')){
        searchObjectFurtherCategorisationHeavyIon.keywords.push(buttonForwardphysics.value)
    }
    
    const buttonInitialstage = document.getElementById("buttonFurtherCategorisationHeavyIonInitialstage");
    if(buttonInitialstage.classList.contains('selected')){
        searchObjectFurtherCategorisationHeavyIon.keywords.push(buttonInitialstage.value)
    }
    
    const buttonJetproperties = document.getElementById("buttonFurtherCategorisationHeavyIonJetproperties");
    if(buttonJetproperties.classList.contains('selected')){
        searchObjectFurtherCategorisationHeavyIon.keywords.push(buttonJetproperties.value)
    }
    
    const buttonOpenHeavyflavor = document.getElementById("buttonFurtherCategorisationHeavyIonOpenHeavyflavor");
    if(buttonOpenHeavyflavor.classList.contains('selected')){
        searchObjectFurtherCategorisationHeavyIon.keywords.push(buttonOpenHeavyflavor.value)
    }
    
    const buttonParticledistributionsandcorrelations = document.getElementById("buttonFurtherCategorisationHeavyIonParticledistributionsandcorrelations");
    if(buttonParticledistributionsandcorrelations.classList.contains('selected')){
        searchObjectFurtherCategorisationHeavyIon.keywords.push(buttonParticledistributionsandcorrelations.value)
    }
    
    const buttonQuarkonia = document.getElementById("buttonFurtherCategorisationHeavyIonQuarkonia");
    if(buttonQuarkonia.classList.contains('selected')){
        searchObjectFurtherCategorisationHeavyIon.keywords.push(buttonQuarkonia.value)
    }
    
    const buttonUltraPeripheralcollisions = document.getElementById("buttonFurtherCategorisationHeavyIonUltraPeripheralcollisions");
    if(buttonUltraPeripheralcollisions.classList.contains('selected')){
        searchObjectFurtherCategorisationHeavyIon.keywords.push(buttonUltraPeripheralcollisions.value)
    }
    
    getAllFiltered()

}